import CONSTANTS from '@/constants'
import { ICouponInformation } from '@/@types'

const LIVE_VIRTUAL_TRAINING_CODES = Object.values(CONSTANTS.LIVE_VIRTUAL_TRAININGS)

export const isLiveVirtualTrainingCoupon = (coupon?: ICouponInformation | null): boolean => {
  if (!coupon) {
    return false
  }

  const couponCodes = [...(coupon.items || []), ...(coupon.plans || [])].map(item => item.code)

  return couponCodes.some(code => LIVE_VIRTUAL_TRAINING_CODES.includes(code))
}
